import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-dynamic-form',
  imports: [
    CommonModule,
    ReactiveFormsModule],
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.less'
})
export class DynamicFormComponent {
  @Input() formFields: any[] = [];
  @Input() submitButtonText: string = "";
  @Input() loading: boolean = false;

  @Output() submitted = new EventEmitter<any>();

  formGroup!: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    const group: { [key: string]: AbstractControl } = {};

    for (const field of this.formFields) {
      let validators = field.required ? [Validators.required] : [];
      let defaultValue = '';

      if(field.type == 'email'){
          validators.push(Validators.email);
      }

      // Voor radiobuttons: stel de eerste optie in als standaard waarde
      if(field.type == 'radiobutton' && field.radioButtons && field.radioButtons.length > 0){
        defaultValue = field.radioButtons[0].label;
      }

      group[field.label] = new FormControl(defaultValue, validators);

    }

    this.formGroup = new FormGroup(group);
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.submitted.emit(this.formGroup.value);
      this.formGroup.reset();
    } else {
      this.formGroup.markAllAsTouched();
    }
  }
}
